import { Box } from "@mui/material";
import { Amplify } from "aws-amplify";
import { ToastContainer } from "react-toastify";

import SignUp from "./components/SignUp";
import awsExports from "./aws-exports";

import "./App.css";
import "react-toastify/dist/ReactToastify.css";

Amplify.configure(awsExports);

function App() {
  return (
    <>
      <Box
        sx={{
          textAlign: "center",
          mt: 4,
          mb: 4,
        }}
      >
        <img src="/img/logo.png" alt="" />
      </Box>
      <SignUp />
      <ToastContainer theme="light" position="top-right" autoClose={5000} />
    </>
  );
}

export default App;
